<mat-card class="sheet-card" *ngIf="!showNextPasswords">

  <!-- Header -->
  <div class="sheet-header" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <div class="sheet-title">Chamada</div>
      <div class="sheet-subtitle">Selecione a unidade e o local para chamar</div>
    </div>

    <mat-icon class="sheet-icon">campaign</mat-icon>
  </div>



  <!-- SENHA EM ATENDIMENTO -->
  <div class="section">
    <div class="section-title">Atendimento atual</div>

    <mat-card class="current-password-card" *ngIf="currentPassword">
      <div fxLayout="row" fxLayoutAlign="space-between center" class="current-wrap">

        <div class="current-left">
          <div class="password-label">Senha em Atendimento</div>
          <div class="password-number">
            {{ currentPassword?.password }}
          </div>

          <div class="password-type badge" fxFlexAlign="center" [ngClass]="{
    'priority': currentPassword?.patientStatus == 'P',
    'normal': currentPassword?.patientStatus != 'P'
  }">
            {{ currentPassword?.patientStatus == "P" ? 'PRIORIDADE' : 'NORMAL' }}
          </div>
        </div>

        <div class="current-right">
          <button mat-raised-button color="warn" class="finish-button" (click)="finishPassword()">
            Finalizar
          </button>
        </div>

      </div>
    </mat-card>

    <!-- Quando não tiver senha atual -->
    <div class="empty-current" *ngIf="!currentPassword">
      <mat-icon>schedule</mat-icon>
      <span>Nenhuma senha em atendimento no momento.</span>
    </div>
  </div>



  <!-- FILTROS -->
  <div class="section">
    <div class="section-title">Configurações da chamada</div>

    <div class="fields" fxLayout="column" fxLayoutGap="12px">

      <mat-form-field appearance="outline" class="w-100-p">
        <mat-label>Unidade</mat-label>
        <mat-select id="register-organizational-professional-participation-cnes-form_it" name="company"
          [formControl]="companyControl" [compareWith]="compareSelect" required>

          <div *ngFor="let company of companyList">
            <mat-option [value]="company">
              {{ company.alias }}
            </mat-option>
          </div>

        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100-p">
        <mat-label>Local para Chamada</mat-label>
        <input id="operation-environment" matInput [matAutocomplete]="autoEnvironment" autocomplete="off" type="search"
          [formControl]="environmentControl" />

        <mat-autocomplete autoActiveFirstOption #autoEnvironment="matAutocomplete" autoActiveFirstOption
          [displayWith]="displaySimpleFn" (optionSelected)="setEnviroment($event.option.value)">

          <mat-option *ngFor="let environment of environmentList" [value]="environment">
            {{ environment.name }}
          </mat-option>

        </mat-autocomplete>
      </mat-form-field>

      <mat-slide-toggle [formControl]="onlyPriorityControl">Só prioridade</mat-slide-toggle>


    </div>
  </div>

  <mat-divider class="sheet-divider"></mat-divider>

  <!-- AÇÕES -->
  <div class="section">
    <div class="section-title">Ações</div>

    <mat-nav-list class="actions-list">

      <mat-list-item fxLayoutAlign="center center" role="listitem" [disabled]="loadingPassword || currentPassword?.id"
        class="action-item action-primary" (click)="nextPassword()">
        <div class="action-content">
          <mat-icon>record_voice_over</mat-icon>
          <span>Chamar a próxima senha</span>
        </div>
      </mat-list-item>

      <mat-list-item fxLayoutAlign="center center" role="listitem" [disabled]="loadingPassword || currentPassword?.id"
        class="action-item" (click)="listPasswords('NEXT')">
        <div class="action-content">
          <mat-icon>queue</mat-icon>
          <span>Próximas senhas</span>
        </div>
      </mat-list-item>

      <mat-list-item fxLayoutAlign="center center" role="listitem" [disabled]="loadingPassword || currentPassword?.id"
        class="action-item" (click)="listPasswords('OLD')">
        <div class="action-content">
          <mat-icon>history</mat-icon>
          <span>Histórico</span>
        </div>
      </mat-list-item>

    </mat-nav-list>
  </div>


</mat-card>
<mat-card *ngIf="showNextPasswords">
  <cw-list-passwords [typeList]="typeList" [companyId]="companyControl?.value?.id"
    [environmentId]="environmentControl?.value?.id" (back)="showNextPasswords = false"
    (oCallPassword)="oCallPassword($event)"></cw-list-passwords>

</mat-card>